import pythonApiClient from "./pythonBaseApi";

const inventarioAlojamientoLogiflexApi = {
  validar: (file, proyectoId, hotel = "CAMPAMENTO") => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("hotel", hotel || "CAMPAMENTO");

    return pythonApiClient.post(
      "/procesos/hoteleria/inventario-alojamiento-logiflex/validar",
      formData,
      {
        headers: {
          "X-Proyecto-ID": proyectoId,
        },
      }
    );
  },

  aplicar: (file, proyectoId, options = {}) => {
    const {
      hotel = "CAMPAMENTO",
      crear = true,
      reactivar = true,
      inactivar = true,
    } = options;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("hotel", hotel || "CAMPAMENTO");
    formData.append("crear", crear ? "true" : "false");
    formData.append("reactivar", reactivar ? "true" : "false");
    formData.append("inactivar", inactivar ? "true" : "false");

    return pythonApiClient.post(
      "/procesos/hoteleria/inventario-alojamiento-logiflex/aplicar",
      formData,
      {
        headers: {
          "X-Proyecto-ID": proyectoId,
        },
      }
    );
  },
};

export default inventarioAlojamientoLogiflexApi;
